import { TranslateText } from "../../../../utils/translation";
import CustomTextField from "../../../common/InputField/Input";
const CustomDiscount = ({
    localHotelDetailsState,
    setLocalHotelDetailsState,
    pa,
    setPa
})=> {

    
     {/* Default Discount */}
     return (<div className="mt-8">
        <div className="font-body text-[18px] mb-2">
            Default Discount
        </div>
        <div className="flex items-center gap-6">
          {["percentage", "amount"].map(type => (
            <div key={type} className="flex items-center gap-2">
              <input
                type="radio"
                className="accent-primary"
                name="default-discount-type"
                checked={pa.title === type}
                onChange={() =>{
                  setLocalHotelDetailsState({
                    ...localHotelDetailsState,
                    priceAdjustment: { 
                        ...pa, 
                        title: type,
                        adjustmentAction: 'DECREMENT'
                     }
                  });
                  setPa({...pa, 
                        title: type,
                        adjustmentAction: 'DECREMENT'
                  });
                }}
              />
              <label className="capitalize">{type}</label>
            </div>
          ))}
          <div className="w-[20%]">
            <CustomTextField
              placeholder="Value"
              value={pa.value || ""}
              onChange={val => {
                setLocalHotelDetailsState({
                  ...localHotelDetailsState,
                  priceAdjustment: { ...pa, value: val }
                });
                setPa({...pa, value: val})
              }
              }
              type="number"
            />
          </div>
        </div>
      </div>)

}
export default CustomDiscount;